import { WriteStrategy } from '../../types/writeStrategy';

export function createDefaultWriteStrategy(): WriteStrategy {
    return {
        commitPreparedData: async ({ preparedData, database }) => {
            await database.batch(...preparedData.map((item) => item.record));
        },
    };
}
